import { render, staticRenderFns } from "./android-url-add-or-update.vue?vue&type=template&id=271a28b2"
import script from "./android-url-add-or-update.vue?vue&type=script&lang=js"
export * from "./android-url-add-or-update.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports